<template>
  <div>
    <van-list v-model="loading" :finished="finished" @load="onLoad">
      <div class="company_card_list" v-if="list.length > 0">
        <div
          class="company_card flex-between"
          v-for="item in list"
          :key="item.id"
        >
          <div class="logo">
            <van-image width="100%" height="100%" :src="baseUrl + item.logo" />
          </div>
          <div class="content flex-colc" @click="handleDetail(item.id)">
            <div class="company_upper">
              <div class="name">{{ item.qyname }}</div>
              <div class="subTit">{{ item.qyename }}</div>
              <div class="label_wrap flex-rowl">
                <div class="label_item" v-if="item.label1_name">
                  {{ item.label1_name }}
                </div>
                <div class="label_item" v-if="item.label2_name">
                  {{ item.label2_name }}
                </div>
                <div class="label_item" v-if="item.label3_name">
                  {{ item.label3_name }}
                </div>
              </div>
            </div>
            <div class="address" v-if="item.provincename">
              所在地区：{{ item.provincename }} {{ item.cityname }}
              {{ item.areaname }}
            </div>
            <div class="address" v-else>所在地区：暂无</div>
            <div class="sign" v-if="item.islinkman_qy">
              <van-image width="24rpx" height="24rpx" />已加入通讯录
            </div>
          </div>
        </div>
      </div>
      <van-empty description="暂无企业or团队" v-else />
    </van-list>
  </div>
</template>
<script>
import { getCompanyList } from "../../api/company";
import storage from "../../utils/storage";
export default {
  name: "companyList",
  props: {
    keyword: String,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      params: {
        Page: 1,
        PageSize: 2,
        keyword: "",
        openid: storage.get("OPENID"),
      },
      list: [],
      loading: false,
      finished: false,
    };
  },
  watch: {
    keyword: function (val) {
      this.list = [];
      this.onLoad(val);
    },
  },
  created() {},
  methods: {
    onLoad(val) {
      let { params } = this;
      params.keyword = val;

      if (params.keyword == "" || !params.keyword) {
        this.loading = false;
        this.list = [];
        return;
      }
      this.loading = true; //防止第一页重复加载
      getCompanyList(params).then((res) => {
        // 加载状态结束
        this.loading = false;
        this.list = this.list.concat(res.list); //追加数据
        if (res.list.length <= res.total) {
          //数据全部加载完成
          this.finished = true;
        } else {
          this.finished = false;
        }
      });
    },

    handleDetail(id) {
      this.$router.push(`/companyIndex/companyDetail/${id}`);
    },
  },
};
</script>
<style lang="less" scoped>
.company_card_list {
  padding: 0 40px;
  .company_card {
    margin-bottom: 30px;
    // border: 2px solid #d8d8d8;
    border-radius: 25px;
    box-shadow: 0px 0px 16px 0px rgba(10, 1, 3, 0.1);
    position: relative;
    // border-radius: 30px;
    padding: 41px 27px;
    align-items: flex-start;
    .logo {
      width: 210px;
      height: 210px;
      flex-shrink: 0;
      margin-right: 15px;
    }
    .content {
      flex: 1;
      font-size: 20px;
      align-items: flex-start;
      justify-content: space-between;
      height: 210px;
      .name {
        font-size: 22px;
      }
      .subTit {
        margin: 20px 0 15px;
      }
      .label_wrap {
        .label_item {
          height: 30px;
          line-height: 30px;
          background: #e5e5e5;
          border-radius: 15px;
          padding: 0 20px;
          color: #444444;
          font-size: 16px;
          margin-right: 18px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .address {
        font-size: 18px;
      }
    }
  }
}
</style>